export const ADMIN_PATH = '/admin1953';